<template>
  <WdsButtonGhost
    secondary
    :href="path"
    :title="jobTitle"
    class="hire-title-company-column"
  >
    <span class="hire-title-company-column__name">
      {{ jobTitle }}
    </span>
  </WdsButtonGhost>
  <WdsText v-if="companyLine" class="tw-pl-1">
    {{ companyLine }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsText } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { useAccountCapabilities } from '@/composables/useAccountCapabilities'

const frag = graphql(`
  fragment HireTitleCompanyColumn on Hire {
    id
    company {
      name
    }
    latestContract {
      jobName
      companyName
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const jobTitle = computed(() => column.value?.latestContract.jobName ?? '')

const { actsAsSupplier } = useAccountCapabilities()

// Suppliers see the client (the hire's company); everyone else the contract's company party.
const companyLine = computed(() =>
  actsAsSupplier.value
    ? (column.value?.company?.name ?? column.value?.latestContract.companyName ?? '')
    : (column.value?.latestContract.companyName ?? column.value?.company?.name ?? ''),
)

const path = computed(() =>
  laravelNamedRoute(namedRoutes.hires.hire.view, { hire: column.value?.id, tab: 'overview' }),
)
</script>

<style lang="scss">
.hire-title-company-column {
  text-align: left;

  &__name {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
